import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ISearchBoxProps, IPeoplePickerItemSelectedProps, PeoplePickerItem, ValidationState, NormalPeoplePicker, IPersonaProps, IPickerItemProps, DialogFooter, DatePicker, DayOfWeek, defaultDatePickerStrings, CheckboxVisibility, Separator, ConstrainMode } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks"
import { getPage } from "../../../../app/Pages"
import { setPage } from "../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../common/Table/Table"
import { reset, dismissMessage, getItems, resetSet, setSelectedCurrencyPairsItems, resetCurrencyPairsSet, setMessage, setIsFilteredCurrencyPairSet, getCurrencyPairs, getAccounts, setIsFilteredAccountSet, resetAccountsSet, setSelectedAccountItems, exportReport } from "./TradingReportSlice"
import { ApiMessage, getHeaders } from "../../../../app/Api"
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { currencyFormatter, formatDate, printComponent, normalizeKey } from "../../../../app/Helpers"
import { TableState } from "../../../common/Table/TableSate"
import { Message } from "../../../common/Message/Message"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { bool, string } from "yup"
import { Popup } from "../../../common/Popup/Popup"
import { GetCurrenciesRequest } from "../../../../repository/Accountant/currency_pb"
import { useReactToPrint } from "react-to-print"
import { PageProps } from "../../PageProps"
import { List } from "../../../common/List/List"
import { GetAccountBalanceReportRequest, GetTreasuryBalanceReportRequest } from "../../../../repository/Accountant/report_pb"
import { GetTreasuriesRequest } from "../../../../repository/Accountant/treasury_pb"
import { TreasuriesPage } from "../../Accountant/Treasuries/TreasuriesPage"
import { CurrenciesPage } from "../../Accountant/Currencies/CurrenciesPage"
import moment from "moment"
import { Form, Formik } from "formik"
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb"
import { AccountStatus, TreasuryStatus } from "../../../../app/Enums"
import { inputs } from "../../../../app/Validation"
import * as Yup from 'yup';
import { GetAccountsRequest } from "../../../../repository/Accountant/account_pb"
import { AccountsPage } from "../../Accountant/Accounts/AccountsPage"
import { ExportTradingReportRequest, GetCurrencyExchangeRatesReportRequest, GetTradingReportRequest } from "../../../../repository/Trading/report_pb"
import { GetCurrencyPairsRequest } from "../../../../repository/Trading/currency_pair_pb"
import { CurrencyPairsPage } from "../../Trading/CurrencyPairs/CurrencyPairsPage"
import report from "../../../../repository/Accountant/report_pb"
import { TextView } from "../../../common/DataView/TextView"

let req: GetTradingReportRequest;
let currecyPairsReq: GetCurrencyPairsRequest;
let getAccountsReq: GetAccountsRequest;
let exportReq: ExportTradingReportRequest;

let org: number = -1;

let getItemsPromise: any;
let getFilterPromise: any;
let actionPromise: any;

const key = "reports/tradingReport"
export const TradingReportPage: React.FunctionComponent<PageProps> = (props) => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const state: {
        set: TableState,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        currencyPairs: TableState,
        accounts: TableState
        isChangeStateLoading: boolean
        totals: any


    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.tradingReportPage.isChangeStateLoading,
            set: state.tradingReportPage.set,
            message: state.tradingReportPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            currencyPairs: state.tradingReportPage.currencyPairs,
            accounts: state.tradingReportPage.accounts,
            totals: state.tradingReportPage.totals


        }
    })

    const [currentAction, setCurrenctAction] = useState(0)
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 1);
    const ref = useRef<HTMLDivElement>(null);
    const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});


    useEffect(() => {
        req = new GetTradingReportRequest();
        currecyPairsReq = new GetCurrencyPairsRequest();
        getAccountsReq = new GetAccountsRequest();

        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
                currecyPairsReq.setOrganization(wrapper)
                getAccountsReq.setOrganization(wrapper)

            }
        }

        if (!props.isSelection) {
            const page = getPage(key)
            dispatch(setTitle(t(normalizeKey(page?.title))));
            dispatch(setPage(page));
        }

        currecyPairsReq.setNumofresults(state.currencyPairs.numberOfResults)
        currecyPairsReq.setOrder(state.currencyPairs.isDescending)


        const statt = new Int32Value();
        statt.setValue(AccountStatus.ACTIVE);

        getAccountsReq.setNumofresults(state.accounts.numberOfResults)
        getAccountsReq.setOrder(state.accounts.isDescending)
        getAccountsReq.setStatus(statt)

        return () => { //clean up
            getItemsPromise?.abort();
            getFilterPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
        }
    }, [])



    const c: IColumn[] = [
        {
            key: 'currencyPairId',
            name: t("pair"),
            minWidth: 50,
            maxWidth: 240,
            isRowHeader: true,
            isResizable: true,
            isMultiline: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.currencyPairId != undefined)
                return <Text>{(item?.currencyPairName)}</Text>; //{item.createdDate}




                //return <Link href="/" underline >{item.name}</Link>;
            },
        },

        {
            key: 'date',
            name: t("date"),
            minWidth: 50,
            maxWidth: 140,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.date != undefined)
                    return <Text>{(item?.date)}</Text>; //{item.createdDate}
            },
        },


        {
            key: 'totalSold',
            name: t("totalSold"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.totalSold != undefined)
                    return <Text>{currencyFormatter(item?.totalSold, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;
            },
        },
        {
            key: 'totalBought',
            name: t("totalBought"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.totalBought != undefined)
                    return <Text>{currencyFormatter(item?.totalBought, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;
            },
        },
        {
            key: 'totalQuantitySold',
            name: t("totalQuantitySold"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.totalQuantitySold != undefined)
                    return <Text>{currencyFormatter(item?.totalQuantitySold, { significantDigits: item?.currencyPairBaseCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairBaseCurrencySymbol })}</Text>;
            },
        },
        {
            key: 'totalQuantityBought',
            name: t("totalQuantityBought"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.totalQuantityBought != undefined)
                    return <Text>{currencyFormatter(item?.totalQuantityBought, { significantDigits: item?.currencyPairBaseCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairBaseCurrencySymbol })}</Text>;
            },
        },
        {
            key: 'totalQuantityAvailable',
            name: t("remaining"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.totalQuantityAvailable != undefined)
                    return <Text>{currencyFormatter(item?.totalQuantityAvailable, { significantDigits: item?.currencyPairBaseCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairBaseCurrencySymbol })}</Text>;
            },
        },
        {
            key: 'totalAvailable',
            name: t("remainingCapital"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.totalAvailable != undefined)
                    return <Text>{currencyFormatter(item?.totalAvailable, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;
            },
        },
        {
            key: 'avgSellPrice',
            name: t("avgSellPrice"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.avgSellPrice != undefined && item?.numberOfSellOperations > 0)
                    return <Text>{currencyFormatter(item?.avgSellPrice, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;

            },
        },
        {
            key: 'avgBuyPrice',
            name: t("avgBuyPrice"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.avgBuyPrice != undefined && item?.numberOfBuyOperations > 0)
                    return <Text>{currencyFormatter(item?.avgBuyPrice, { significantDigits: item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: item?.currencyPairQuoteCurrencySymbol })}</Text>;

            },
        },

        {
            key: 'numberOfSellOperations',
            name: t("numberOfSellOperations"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.numberOfSellOperations != undefined)
                    return <Text>{item?.numberOfSellOperations}</Text>;

            },
        },
        {
            key: 'numberOfBuyOperations',
            name: t("numberOfBuyOperations"),
            minWidth: 50,
            maxWidth: 110,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                if (item?.numberOfBuyOperations != undefined)
                    return <Text>{item?.numberOfBuyOperations}</Text>;

            },
        },

    ];


    const mainOptions: ICommandBarItemProps[] = [

        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                handlePrint(reactToPrintContent);
            }
        },
    ];



    const onPairsFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetCurrencyPairsSet())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        currecyPairsReq.setSearch(wrapper)
        currecyPairsReq.setNextto(undefined)
        dispatch(setIsFilteredCurrencyPairSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
        return [];

    }
    const onAccountsFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {

        dispatch(resetAccountsSet())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        getAccountsReq.setSearch(wrapper)
        getAccountsReq.setNextto(undefined)

        dispatch(setIsFilteredAccountSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getAccounts({ body: getAccountsReq, headers: getHeaders() }))
        return [];

    }
    return (
        <Stack >

            <Popup isOpen={(currentAction == 1000)} title={t("pair")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrencyPairsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedCurrencyPairsItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 1001)} title={t("accounts")} onDismiss={() => { setCurrenctAction(0) }} >

                <AccountsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedAccountItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }


            <Formik
                enableReinitialize={true}
                initialValues={{
                    from: moment(fromDate, 'YYYY-MM-DD').startOf('day').toDate(),
                    to: moment(new Date(), 'YYYY-MM-DD').endOf('day').toDate(),
                    group: { key: 0, text: t("daily") },

                }}


                onSubmit={(values, actions) => {

                    let currencyPair = state.currencyPairs.selected.at(0);
                    let account = state.accounts.selected.at(0);
                    if (account) {
                        const wrapper = new StringValue();
                        wrapper.setValue(account.internalId)
                        req.setAccount(wrapper);
                    } else {
                        req.setAccount(undefined);
                    }
                    exportReq = new ExportTradingReportRequest();
                    exportReq.setOrganization(req.getOrganization())
                    if (currencyPair) {
                        let stringV = new StringValue()
                        stringV.setValue(currencyPair?.id ?? undefined)
                        req.setCurrencypair(stringV);
                        exportReq.setCurrencypair(stringV);

                    } else {
                        req.setCurrencypair(undefined);
                        exportReq.setCurrencypair(undefined);

                    }
                    const wrapper = new Timestamp();
                    wrapper.fromDate(moment(values.from, 'YYYY-MM-DD').startOf('day').toDate())
                    req.setFrom(wrapper)

                    const wrapperTo = new Timestamp();
                    wrapperTo.fromDate(moment(values.to, 'YYYY-MM-DD').endOf('day').toDate())
                    req.setTo(wrapperTo)

                    req.setGroupby(values.group.key)


                    exportReq.setAccount(req.getAccount());
                    exportReq.setFrom(req.getFrom())
                    exportReq.setTo(req.getTo())
                    exportReq.setGroupby(req.getGroupby())
                    exportReq.setExporttype(1)



                    const labels: report.Label[] = [];
                    let r = new report.Label();
                    let value = new StringValue();
                    value.setValue(formatDate(moment(values.from, 'YYYY-MM-DD').startOf('day').toDate()))
                    r.setLabelvalue(t("from"));
                    r.setValue(value)
                    r.setPropartyname("from")
                    labels.push(r)

                    r = new report.Label();
                    value = new StringValue();
                    value.setValue(formatDate(moment(values.to, 'YYYY-MM-DD').endOf('day').toDate()))
                    r.setLabelvalue(t("to"));
                    r.setValue(value)
                    r.setPropartyname("to")
                    labels.push(r)

                    r = new report.Label();
                    value = new StringValue();
                    value.setValue(values.group.text)
                    r.setLabelvalue(t("grouping"));
                    r.setValue(value)
                    r.setPropartyname("groupby")
                    labels.push(r)

                    r = new report.Label();
                    value = new StringValue();
                    value.setValue(currencyPair?.name ?? "")
                    r.setLabelvalue(t("pair"));
                    r.setValue(value)
                    r.setPropartyname("pair")
                    labels.push(r)


                    r = new report.Label();
                    value = new StringValue();
                    value.setValue((account?.name ?? "") + " - " + (account?.id ?? ""))
                    r.setLabelvalue(t("account"));
                    r.setValue(value)
                    r.setPropartyname("account")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("generatedDate"));
                    r.setPropartyname("generateddate")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("generatedBy"));
                    r.setPropartyname("generatedby")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("date"));
                    r.setPropartyname("date")
                    labels.push(r)





                    
            
                    r = new report.Label();
                    r.setLabelvalue(t("totalSold"));
                    r.setPropartyname("totalSold")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("totalBought"));
                    r.setPropartyname("totalBought")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("totalQuantitySold"));
                    r.setPropartyname("totalQuantitySold")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("totalQuantityBought"));
                    r.setPropartyname("totalQuantityBought")
                    labels.push(r)


                    r = new report.Label();
                    r.setLabelvalue(t("avgSellPrice"));
                    r.setPropartyname("avgSellPrice")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("avgBuyPrice"));
                    r.setPropartyname("avgBuyPrice")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("numberOfSellOperations"));
                    r.setPropartyname("numberOfSellOperations")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("numberOfBuyOperations"));
                    r.setPropartyname("numberOfBuyOperations")
                    labels.push(r)

                    r = new report.Label();
                    r.setLabelvalue(t("remaining"));
                    r.setPropartyname("totalQuantityAvailable")
                    labels.push(r)
                    r = new report.Label();
                    r.setLabelvalue(t("remainingCapital"));
                    r.setPropartyname("totalAvailable")
                    labels.push(r)
              

                    r = new report.Label();
                    value = new StringValue();
                    value.setValue((((new Date()).getTimezoneOffset()) * -1) + "")
                    r.setValue(value);
                    r.setPropartyname("timezone")
                    labels.push(r)


                    exportReq.setLabelsList(labels)

                    getItemsPromise?.abort();
                    getItemsPromise = dispatch(getItems({ body: req, headers: getHeaders() }))


                }}

            >
                {formkikProps => (
                    <Form >

                        <Stack tokens={{ childrenGap: 10, padding: "0px 33% 10px 3%" }}>
                            <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10 }}>
                                <Stack.Item grow>
                                    <DatePicker
                                        isRequired
                                        firstDayOfWeek={DayOfWeek.Sunday}
                                        label={t("from")}
                                        placeholder={t("from")}
                                        disabled={state.set.isFetching}
                                        value={formkikProps.values.from}
                                        ariaLabel={t("from")}
                                        formatDate={(e) => {
                                            return formatDate(e, 'YYYY-MM-DD')
                                        }}
                                        parseDateFromString={(date) => {
                                            return moment(date, 'YYYY-MM-DD').startOf('day').toDate();
                                        }}
                                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                        strings={defaultDatePickerStrings}
                                        onSelectDate={(date: Date | null | undefined) => {

                                            formkikProps.setFieldValue("from", date)
                                        }}

                                    />
                                </Stack.Item>
                                <Stack.Item grow>
                                    <DatePicker
                                        isRequired
                                        firstDayOfWeek={DayOfWeek.Sunday}
                                        label={t("to")}
                                        placeholder={t("to")}
                                        disabled={state.set.isFetching}
                                        value={formkikProps.values.to}
                                        ariaLabel={t("to")}
                                        formatDate={(e) => {
                                            return formatDate(e, 'YYYY-MM-DD')
                                        }}
                                        parseDateFromString={(date) => {
                                            return moment(date, 'YYYY-MM-DD').endOf('day').toDate();
                                        }}
                                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                        strings={defaultDatePickerStrings}
                                        onSelectDate={(date: Date | null | undefined) => {
                                            if (date != undefined)
                                                if (moment(date).isSameOrAfter(formkikProps.values.from)) {
                                                    formkikProps.setFieldValue("to", date)
                                                } else {
                                                    formkikProps.setFieldValue("to", new Date())
                                                }
                                        }}

                                    />
                                </Stack.Item>
                                <Stack.Item grow>
                                    <ComboBox
                                        label={t("grouping")}
                                        required
                                        allowFreeform={true}
                                        autoComplete={'on'}
                                        disabled={state.set.isFetching}
                                        options={[{ key: 3, text: t("hourly") }, { key: 0, text: t("daily") }, { key: 1, text: t("monthly") }, { key: 2, text: t("yearly") },]}
                                        selectedKey={formkikProps.values.group.key}
                                        onChange={(e, o) => {
                                            formkikProps.setFieldValue("group", { key: o?.key, text: o?.text })
                                        }} />
                                </Stack.Item>
                            </Stack>


                            <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10 }}>

                                <Stack.Item grow>
                                    <Label disabled={state.set.isFetching}>{t("pair")}</Label>
                                    <List
                                        inputProps={{ placeholder: t("pair") }}
                                        disabled={state.set.isFetching}
                                        suggestionsHeaderText={t('pair')}
                                        isLoading={state.currencyPairs.items.length == 0 ? state.currencyPairs.isFetching : false}
                                        isSearching={state.currencyPairs.items.length > 0 ? state.currencyPairs.isFetching : false}
                                        moreSuggestionsAvailable={state.currencyPairs.hasMore && !state.currencyPairs.isFetching}
                                        suggestions={state.currencyPairs.items.length > 0 ? state.currencyPairs.items.map(e => { return { item: { key: e.id, text: e.name, imageInitials: e?.baseCurrencySymbol + "/" + e?.quoteCurrencySymbol, secondaryText: (e?.baseCurrencyCode == "" ? e?.baseCurrencyId : e?.baseCurrencyCode) + "-" + (e?.quoteCurrencyCode == "" ? e?.quoteCurrencyId : e?.quoteCurrencyCode), imageUrl: e?.iconSource } } as ISuggestionModel<IPersonaProps> }) : []}
                                        onGetMoreResults={() => {
                                            if (state.currencyPairs.items.length > 0 && !state.currencyPairs.isFetching) {
                                                const wrapper = new StringValue();
                                                wrapper.setValue(state.currencyPairs.items.at(state.currencyPairs.items.length - 1).id);
                                                currecyPairsReq.setNextto(wrapper)
                                                getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
                                            }
                                        }}
                                        onSuggestionClick={(ev?, item?: any, index?: number) => {
                                            var u = state.currencyPairs.items.findIndex(e => e.id == item.key)
                                            if (u >= 0) {
                                                dispatch(setSelectedCurrencyPairsItems([state.currencyPairs.items.at(u)]))
                                            }


                                        }}
                                        isPeoplePicker={true}
                                        selectedItems={state.currencyPairs.selected.length > 0 ? state.currencyPairs.selected.map(e => { return { key: e.id, text: e.name, imageInitials: e?.baseCurrencySymbol + "/" + e?.quoteCurrencySymbol, secondaryText: (e?.baseCurrencyCode == "" ? e?.baseCurrencyId : e?.baseCurrencyCode) + "-" + (e?.quoteCurrencyCode == "" ? e?.quoteCurrencyId : e?.quoteCurrencyCode), imageUrl: e?.iconSource } as IPersonaProps }) : []}
                                        onChange={(e) => {
                                            dispatch(setSelectedCurrencyPairsItems([]))


                                        }}
                                        onEmptyInputFocus={() => {
                                            dispatch(resetCurrencyPairsSet())
                                            currecyPairsReq.setSearch(undefined)
                                            currecyPairsReq.setNextto(undefined)
                                            dispatch(setIsFilteredCurrencyPairSet(false))
                                            getFilterPromise?.abort()
                                            getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
                                            return []
                                        }}
                                        onFilterChanged={onPairsFilterChanged}
                                        endButtons={[
                                            {
                                                title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                onClick: () => {
                                                    setCurrenctAction(1000)

                                                }
                                            }]}
                                    />

                                </Stack.Item>
                                <Stack.Item grow>
                                    <Label disabled={state.set.isFetching}>{t("account")}</Label>
                                    <List
                                        isPeoplePicker={true}
                                        suggestionsHeaderText={t('accounts')}
                                        isLoading={state.accounts.items.length == 0 ? state.accounts.isFetching : false}
                                        isSearching={state.accounts.items.length > 0 ? state.accounts.isFetching : false}
                                        moreSuggestionsAvailable={state.accounts.hasMore && !state.accounts.isFetching}
                                        suggestions={state.accounts.items.length > 0 ? state.accounts.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : []}
                                        onGetMoreResults={() => {
                                            if (state.accounts.items.length > 0 && !state.accounts.isFetching) {
                                                const wrapper = new StringValue();
                                                wrapper.setValue(state.accounts.items.at(state.accounts.items.length - 1).internalId);
                                                getAccountsReq.setNextto(wrapper)
                                                getFilterPromise = dispatch(getAccounts({ body: getAccountsReq, headers: getHeaders() }))
                                            }
                                        }}
                                        onSuggestionClick={(ev?, item?: any, index?: number) => {
                                            var u = state.accounts.items.findIndex(e => e.internalId == item.key)
                                            if (u >= 0) {
                                                dispatch(setSelectedAccountItems([state.accounts.items.at(u)]))
                                            }

                                        }}
                                        inputProps={{ placeholder: t("account") }}

                                        disabled={state.set.isFetching}
                                        selectedItems={state.accounts.selected.length > 0 ? state.accounts.selected.map(e => { return { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } as IPersonaProps }) : []}
                                        onChange={(e) => {
                                            dispatch(setSelectedAccountItems([]))
                                        }}
                                        onEmptyInputFocus={() => {
                                            dispatch(resetAccountsSet())
                                            getAccountsReq.setSearch(undefined)
                                            getAccountsReq.setNextto(undefined)
                                            dispatch(setIsFilteredAccountSet(false))
                                            getFilterPromise?.abort()
                                            getFilterPromise = dispatch(getAccounts({ body: getAccountsReq, headers: getHeaders() }))

                                        }}
                                        onFilterChanged={onAccountsFilterChanged}
                                        endButtons={[
                                            {
                                                title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                onClick: () => {
                                                    setCurrenctAction(1001);

                                                }
                                            }]}
                                    />

                                </Stack.Item>
                            </Stack>


                            <DialogFooter>
                                <PrimaryButton disabled={state.set.isFetching} text={state.set.isFetching ? undefined : t("generateReport")} type="submit" >

                                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.set.isFetching ? "block" : "none") } }} />

                                </PrimaryButton>

                                <DefaultButton disabled={state.set.isFetching} text={t("clearFilter")} onClick={() => {
                                    formkikProps.resetForm()
                                    req.setCurrencypair(undefined)
                                    req.setAccount(undefined)
                                    req.setGroupby(0)
                                    req.setFrom(undefined)
                                    req.setTo(undefined)
                                    dispatch(setSelectedCurrencyPairsItems([]))
                                    dispatch(setSelectedAccountItems([]))
                                    dispatch(resetSet())


                                }} />
                            </DialogFooter>
                        </Stack>
                        {state.set.items.length > 0 ? <CommandBar
                            items={[
                                {
                                    key: 'export',
                                    text: t("export"),
                                    iconProps: { iconName: "DownloadDocument", styles: { root: { fontWeight: "bold" } } },
                                    title: t("export"),
                                    disabled: state.set.isFetching,
                                    commandBarButtonAs: (e) => {
                                        return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 1 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 1 ? undefined : e.text}  >
                                            <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 1 ? "block" : "none") } }} />
                                        </CommandBarButton>;
                                    },
                                    subMenuProps: {
                                        items: [{
                                            key: 'exportToExcel',
                                            text: t('exportToExcel'),
                                            title: t("exportToExcel"),
                                            iconProps: { iconName: 'ExcelDocument' },

                                            onClick: () => {
                                                if (!state.isChangeStateLoading && exportReq) {

                                                    exportReq.setExporttype(1)
                                                    setCurrenctAction(1)
                                                    getItemsPromise = dispatch(exportReport({
                                                        body: exportReq, headers: getHeaders()
                                                    }))

                                                }

                                            }
                                        },
                                        {
                                            key: 'exportToCsv',
                                            text: t("exportToCsv"),
                                            title: t("exportToCsv"),

                                            iconProps: { iconName: 'ReportDocument' },
                                            onClick: () => {
                                                if (!state.isChangeStateLoading && exportReq) {
                                                    exportReq.setExporttype(2)
                                                    setCurrenctAction(1)
                                                    getItemsPromise = dispatch(exportReport({
                                                        body: exportReq, headers: getHeaders()
                                                    }))

                                                }

                                            }
                                        },

                                        ]
                                    },


                                },
                                {
                                    key: 'print',
                                    text: t("print"),
                                    iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
                                    title: t("print"),
                                    onClick: () => {
                                        handlePrint(reactToPrintContent);
                                    }
                                },

                            ]}

                        /> : undefined}
                    </Form>
                )}
            </Formik>


            <Table
                setKey="tradingReport"
                items={state.set.items}
                checkboxVisibility={props.isSelection ? CheckboxVisibility.always : CheckboxVisibility.onHover}
                columns={c}
                selectionMode={SelectionMode.none}
                enableShimmer={state.set.items.length == 0 && state.set.isFetching}
                isColumnSortingEnabled={state.set.selected.length == 0}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={props.isSelection ? DetailsListLayoutMode.fixedColumns : DetailsListLayoutMode.fixedColumns}
                compRef={ref}
                height={state.message == undefined ? "calc(100vh - 435px)" : "calc(100vh - 484px)"}


            />
            {state.totals ? <>
                <Separator alignContent="start"><b>{t("totalPeriod")}</b></Separator>

                <Stack tokens={{ childrenGap: 10 }} horizontal>

                    <TextView label={t("totalSold")} value={state.totals?.totalSold != undefined ? currencyFormatter(state.totals?.totalSold, { significantDigits: state.totals?.quoteCurrency?.decimalPlaces ?? 9, symbol: state.totals?.quoteCurrency?.symbol }) : ""} />

                    <TextView label={t("totalBought")} value={state.totals?.totalBought != undefined ? currencyFormatter(state.totals?.totalBought, { significantDigits: state.totals?.quoteCurrency?.decimalPlaces ?? 9, symbol: state.totals?.quoteCurrency?.symbol }) : ""} />

                    <TextView label={t("totalQuantitySold")} value={state.totals?.totalQuantitySold != undefined ? currencyFormatter(state.totals?.totalQuantitySold, { significantDigits: state.totals?.baseCurrency?.decimalPlaces ?? 9, symbol: state.totals?.baseCurrency?.symbol }) : ""} />

                    <TextView label={t("totalQuantityBought")} value={state.totals?.totalQuantityBought != undefined ? currencyFormatter(state.totals?.totalQuantityBought, { significantDigits: state.totals?.baseCurrency?.decimalPlaces ?? 9, symbol: state.totals?.baseCurrency?.symbol }) : ""} />

                    <TextView label={t("remaining")} value={state.totals?.totalQuantityAvailable != undefined ? currencyFormatter(state.totals?.totalQuantityAvailable, { significantDigits: state.totals?.baseCurrency?.decimalPlaces ?? 9, symbol: state.totals?.baseCurrency?.symbol }) : ""} />

                    <TextView label={t("remainingCapital")} value={state.totals?.totalAvailable != undefined ? currencyFormatter(state.totals?.totalAvailable, { significantDigits: state.totals?.quoteCurrency?.decimalPlaces ?? 9, symbol: state.totals?.quoteCurrency?.symbol }) : ""} />

                    <TextView label={t("avgSellPrice")} value={state.totals?.avgSellPrice != undefined && state.totals?.numberOfSellOperations > 0 ? currencyFormatter(state.totals?.avgSellPrice, { significantDigits: state.totals?.quoteCurrency?.decimalPlaces ?? 9, symbol: state.totals?.quoteCurrency?.symbol }) : ""} />

                    <TextView label={t("avgBuyPrice")} value={state.totals?.avgBuyPrice != undefined && state.totals?.numberOfBuyOperations > 0 ? currencyFormatter(state.totals?.avgBuyPrice, { significantDigits: state.totals?.quoteCurrency?.decimalPlaces ?? 9, symbol: state.totals?.quoteCurrency?.symbol }) : ""} />

                    <TextView label={t("numberOfSellOperations")} value={state.totals?.numberOfSellOperations != undefined ? state.totals?.numberOfSellOperations + "" : ""} />

                    <TextView label={t("numberOfBuyOperations")} value={state.totals?.numberOfBuyOperations != undefined ? state.totals?.numberOfBuyOperations + "" : ""} />

                </Stack>
            </> : undefined
            }


        </Stack >



    );
}




